'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reselect = require('reselect');

var _metrixCommon = require('metrix-common');

var _messages = require('../../messages');

var _messages2 = _interopRequireDefault(_messages);

var _saga = require('../../sagas/workflow/saga');

var _saga2 = _interopRequireDefault(_saga);

var _Step = require('../../components/Workflow/Step');

var _Step2 = _interopRequireDefault(_Step);

var _selectAnonymous = require('../../selectors/workflow/selectAnonymous');

var _selectControl = require('../../selectors/workflow/selectControl');

var _selectStep = require('../../selectors/workflow/selectStep');

var _selectStages = require('../../selectors/workflow/selectStages');

var _selectReturns = require('../../selectors/workflow/selectReturns');

var _selectValid = require('../../selectors/workflow/selectValid');

var _reduceEntity = require('../../actions/workflow/reduceEntity');

var _reduceAnonymous = require('../../actions/workflow/reduceAnonymous');

var _step = require('../../actions/workflow/step');

var _setReturn = require('../../actions/workflow/setReturn');

var _selectEntity = require('../../selectors/workflow/selectEntity');

var _executeAction = require('../../actions/workflow/executeAction');

var _selectStepAnalytics = require('../../selectors/workflow/selectStepAnalytics');

var _getWorkflowConfiguration = require('../../actions/workflow/getWorkflowConfiguration');

var _selectWorkflowConfiguration = require('../../selectors/workflow/selectWorkflowConfiguration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Workflow = function Workflow(_ref) {
    var context = _ref.context,
        location = _ref.location,
        allowAnonymous = _ref.allowAnonymous,
        doReduceAnonymous = _ref.doReduceAnonymous,
        doReduceEntity = _ref.doReduceEntity,
        doStep = _ref.doStep,
        analytics = _ref.analytics,
        stepAnalytics = _ref.stepAnalytics,
        doGetWorkflowConfiguration = _ref.doGetWorkflowConfiguration,
        workflowConfiguration = _ref.workflowConfiguration,
        props = _objectWithoutProperties(_ref, ['context', 'location', 'allowAnonymous', 'doReduceAnonymous', 'doReduceEntity', 'doStep', 'analytics', 'stepAnalytics', 'doGetWorkflowConfiguration', 'workflowConfiguration']);

    _react2.default.useEffect(function () {
        if (context && context.doSetMessages) context.doSetMessages(_messages2.default);

        if (!workflowConfiguration) doGetWorkflowConfiguration();

        var params = new URLSearchParams(location.search);
        var entity = params.get('entity');

        if (allowAnonymous === true) doReduceAnonymous(true);
        doReduceEntity(entity);
        doStep('none');
    }, []);

    return _react2.default.createElement(_Step2.default, _extends({
        context: context,
        location: location,
        analytics: analytics,
        stepAnalytics: stepAnalytics,
        allowAnonymous: allowAnonymous,
        doReduceAnonymous: doReduceAnonymous,
        doReduceEntity: doReduceEntity,
        doStep: doStep,
        workflowConfiguration: workflowConfiguration
    }, props));
};

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    anonymous: (0, _selectAnonymous.selectAnonymous)(),
    control: (0, _selectControl.selectControl)(),
    step: (0, _selectStep.selectStep)(),
    stepAnalytics: (0, _selectStepAnalytics.selectStepAnalytics)(),
    stages: (0, _selectStages.selectStages)(),
    returns: (0, _selectReturns.selectReturns)(),
    valid: (0, _selectValid.selectValid)(),
    entity: (0, _selectEntity.selectEntity)(),
    workflowConfiguration: (0, _selectWorkflowConfiguration.selectWorkflowConfiguration)()
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        doStep: function doStep(payload) {
            return dispatch((0, _step.step)(payload));
        },
        doSetReturn: function doSetReturn(payload) {
            return dispatch((0, _setReturn.setReturn)(payload));
        },
        doReduceEntity: function doReduceEntity(payload) {
            return dispatch((0, _reduceEntity.reduceEntity)(payload));
        },
        doReduceAnonymous: function doReduceAnonymous(payload) {
            return dispatch((0, _reduceAnonymous.reduceAnonymous)(payload));
        },
        doReduceDynamicDate: function doReduceDynamicDate(payload) {
            return dispatch((0, _reduceEntity.reduceDynamicDate)(payload));
        },
        doExecuteAction: function doExecuteAction(payload) {
            return dispatch((0, _executeAction.executeAction)(payload));
        },
        doGetWorkflowConfiguration: function doGetWorkflowConfiguration() {
            return dispatch((0, _getWorkflowConfiguration.getWorkflowConfiguration)());
        }
    };
};

var withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

var withSaga = (0, _metrixCommon.withSagas)({ key: 'workflow', saga: _saga2.default });

var WrappedWorkflow = (0, _metrixCommon.withAnalytics)(Workflow, true);

exports.default = (0, _redux.compose)(withConnect, withSaga)(WrappedWorkflow);